import { useForm } from '@inertiajs/inertia-react'
import ValidationErrors from '@/Components/ValidationErrors';
import Button from '@/Components/Button';
import { Inertia } from '@inertiajs/inertia';
import Swal from 'sweetalert2';
import Label from '../Label';
import { useEffect, useState } from 'react';
import Radio from '../Radio';

export const ScheduleTypeForm = ({ branchOffice }) => {

	const { data, setData, post, errors, processing, reset } = useForm({
		'schedule_description': '',
		'price': '',
		'weekend_price': '',
		'duration': '',
		'type': 'individual',
		'softland_id': null,
		'weekend_description': '',
		'weekend_softland_id': null,
	})

	const onHandleChange = (event) => {
		setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
	};
	const scheduleTypeSubmit = (e) => {
		e.preventDefault()
		console.log('shega')
		post(route('schedule-type.store', branchOffice.slug), {
			onSuccess: () => {
				reset();
			}
		})
	}


	return (
		<>
			<ValidationErrors errors={errors} />
			<form onSubmit={scheduleTypeSubmit}>
				<div className="grid grid-cols-3 gap-1 mt-5">
					<input
						type="text"
						name="schedule_description"
						className="w-full rounded px-5 py-2"
						placeholder="Descripción"
						onChange={onHandleChange}
						value={data.schedule_description}
						required
					/>

					<input
						type="number"
						name="price"
						className="w-full rounded px-5 py-2"
						placeholder="Precio"
						onChange={onHandleChange}
						value={data.price}
						required
					/>

					<input
						type="text"
						name="softland_id"
						className="w-full rounded px-5 py-2"
						placeholder="Codigo de Softland"
						onChange={onHandleChange}
						value={data.softland_id}
						required
					/>

					<input
						type="text"
						name="weekend_description"
						className="w-full rounded px-5 py-2"
						placeholder="Descripción FDS"
						onChange={onHandleChange}
						value={data.weekend_description}
						required
					/>
					<input
						type="number"
						name="weekend_price"
						className="w-full rounded px-5 py-2"
						placeholder="Precio FDS"
						onChange={onHandleChange}
						value={data.weekend_price}
						required
					/>

					<input
						type="text"
						name="weekend_softland_id"
						className="w-full rounded px-5 py-2"
						placeholder="Codigo de Softland FDS"
						onChange={onHandleChange}
						value={data.weekend_softland_id}
						required
					/>

					<input
						type="number"
						name="duration"
						className="w-full rounded px-5 py-2"
						placeholder="Duración en horas"
						onChange={onHandleChange}
						value={data.duration}
						required
					/>
				</div>

				<div>
					<div className="flex items-center gap-4 my-3">
						<Radio
							value={data.type}
							binding="individual"
							name="type"
							handleChange={() => {
								setData('type', 'individual');
							}}
						>
							Individual
						</Radio>

						<Radio
							value={data.type}
							binding="group"
							name="type"
							handleChange={() => {
								setData('type', 'group');
							}}
						>
							Grupal
						</Radio>

						<Radio
							value={data.type}
							binding="birthday"
							name="type"
							handleChange={() => {
								setData('type', 'birthday');
							}}
						>
							Cumpleaños
						</Radio>
						<Radio
							value={data.type}
							binding="skating_class"
							name="type"
							handleChange={() => {
								setData('type', 'skating_class');
							}}
						>
							Clase diaria
						</Radio>
						<Radio
							value={data.type}
							binding="skating_class_monthly"
							name="type"
							handleChange={() => {
								setData('type', 'skating_class_monthly');
							}}
						>
							Clase mensual
						</Radio>
					</div>
					{/* <div className="flex items-center gap-2 my-3">
						<input
							type="checkbox"
							name="is_group"
							id="is_group"
							className="rounded-sm"
							onChange={onHandleChange}
							checked={data.is_group}
							/>
						<Label value="Grupal" forInput="is_group" />
					</div> */}

					<Button processing={processing}>agregar</Button>
				</div>
			</form>
		</>
	)
}



export const ScheduleTypeResults = ({ scheduleTypes, branchOfficeSlug }) => {
	return (
		scheduleTypes && scheduleTypes.length > 0 ? scheduleTypes.map((type, key) => (
			<ScheduleType key={`schedule-type-item-${key}`} office={branchOfficeSlug} {...type} />
		))
			:
			<div className="bg-white px-3 py-2 rounded mt-5 text-center">
				<p>No hay periodos en esta sucursal</p>
			</div>
	)
}

const ScheduleType = ({ id, schedule_description, softland_id, weekend_softland_id, weekend_description, price, weekend_price, duration, type, office }) => {
	const [isEditing, setIsEditing] = useState(false);

	const { data, setData, put, errors, processing, reset } = useForm({
		schedule_description,
		price,
		weekend_price,
		duration,
		type,
		softland_id,
		weekend_softland_id,
		weekend_description,
		// is_group,
	});

	const onHandleChange = (event) => {
		setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
	};

	const openSwalDelete = () => {
		Swal.fire({
			icon: 'warning',
			title: 'Estás seguro de que quieres eliminar este periodo?',
			html: `<strong>"${schedule_description}"</strong>`,
			buttonsStyling: false,
			showCancelButton: true,
			customClass: {
				confirmButton: 'mx-1 py-2 px-4 rounded bg-red-600 text-white',
				cancelButton: 'mx-1 py-2 px-4 rounded bg-gray-500 text-white'
			},
			reverseButtons: true,
			confirmButtonText: 'Eliminar',
			cancelButtonText: 'Cancelar'
		}).then(({ isConfirmed }) => {
			if (isConfirmed) {
				Inertia.delete(route('schedule-type.delete', { office, scheduleType: id }));
			}
		});
	}

	const scheduleTypeSubmit = (event) => {
		event.preventDefault();

		put(route('schedule-type.update', { office, scheduleType: id }), {
			onSuccess: () => {
				setIsEditing(false);
			}
		})
	}

	useEffect(() => {
		if (!isEditing) {
			reset();
		}
	}, [isEditing])

	return (
		<div className="bg-white px-3 py-2 rounded mt-5 flex justify-between">
			{isEditing ? (
				<form onSubmit={scheduleTypeSubmit}>
					<div className="grid grid-cols-3 gap-1 mt-5">
						<input
							type="text"
							name="schedule_description"
							className="w-full rounded px-5 py-2"
							placeholder="Descripción"
							onChange={onHandleChange}
							value={data.schedule_description}
							required
						/>

						<input
							type="number"
							name="price"
							className="w-full rounded px-5 py-2"
							placeholder="Precio"
							onChange={onHandleChange}
							value={data.price}
							required
						/>

						<input
							type="text"
							name="softland_id"
							className="w-full rounded px-5 py-2"
							placeholder="Codigo de Softland"
							onChange={onHandleChange}
							value={data.softland_id}
							required
						/>

						<input
							type="text"
							name="weekend_description"
							className="w-full rounded px-5 py-2"
							placeholder="Descripción FDS"
							onChange={onHandleChange}
							value={data.weekend_description}
							required
						/>


						<input
							type="number"
							name="weekend_price"
							className="w-full rounded px-5 py-2"
							placeholder="Precio FDS"
							onChange={onHandleChange}
							value={data.weekend_price}
							required
						/>

						<input
							type="text"
							name="weekend_softland_id"
							className="w-full rounded px-5 py-2"
							placeholder="Codigo de Softland FDS"
							onChange={onHandleChange}
							value={data.weekend_softland_id}
							required
						/>
						<input
							type="number"
							name="duration"
							className="w-full rounded px-5 py-2"
							placeholder="Duración en horas"
							onChange={onHandleChange}
							value={data.duration}
							required
						/>
					</div>

					<div>
						<div className="flex items-center gap-4 my-3">
							<Radio
								value={data.type}
								binding="individual"
								name="type"
								handleChange={() => {
									setData('type', 'individual');
								}}
							>
								Individual
							</Radio>

							<Radio
								value={data.type}
								binding="group"
								name="type"
								handleChange={() => {
									setData('type', 'group');
								}}
							>
								Grupal
							</Radio>

							<Radio
								value={data.type}
								binding="birthday"
								name="type"
								handleChange={() => {
									setData('type', 'birthday');
								}}
							>
								Cumpleaños
							</Radio>

							<Radio
								value={data.type}
								binding="skating_class"
								name="type"
								handleChange={() => {
									setData('type', 'skating_class');
								}}
							>
								Clase diaria
							</Radio>
							<Radio
								value={data.type}
								binding="skating_class_monthly"
								name="type"
								handleChange={() => {
									setData('type', 'skating_class_monthly');
								}}
							>
								Clase mensual
							</Radio>
						</div>

						<div className="flex items-center gap-4">
							<Button processing={processing}>Actualizar</Button>
							<Button onClick={() => setIsEditing(false)} type="button" style={{ backgroundColor: 'rgba(107, 114, 128, 1)' }}>Cancelar</Button>
						</div>
					</div>
				</form>
			) : (
				<>
					<p className="font-bold">{schedule_description}</p>
					{/* <div>{is_group ? 'Grupal' : ''}</div> */}
					<div>
						{(() => {
							switch (type) {
								case 'individual':
									return '';
								case 'group':
									return 'Grupal';
								case 'birthday':
									return 'Cumpleaños';
								case 'skating_class':
									return 'Clase diaria';
								case 'skating_class_monthly':
									return 'Clase mensual'
							}
						})()}
					</div>
					<div className="flex items-center gap-4">
						<Button onClick={() => setIsEditing(true)}>Editar</Button>
						<Button onClick={openSwalDelete} className="bg-red-600 text-white">Eliminar</Button>
					</div>
				</>
			)}
		</div>
	);
}
